module.exports = __webpack_public_path__ + "media/images/flags/32/Panama-97acc06f1baec8602f491b1bb353e73f.png";